<template>
    <div class="map-view">
        <Filter @filtered="filterAll" />
        <Panel :class="{ 'show': panelShow }" :events="events" @hidePanel="hidePanel" />
        <GoogleMap api-key="AIzaSyBKds2uWBtwsGgHwYQg2rh17S0oIu1jpZs" class="map" style="width: 100%;" :styles="mapStyle"
            :center="center" :zoom="zoom" :mapTypeControl="false">
            <MarkerCluster v-if="enable_clustering.value == 1">
                <Marker v-for="location in filteredLocations" :key="location.uid"
                    :options="{ position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) } }">
                    <InfoWindow @closeclick="hidePanel()" :ref="(el) => (infoWindows[location.name] = el)">
                        <div class="content">
                            <h4 id="firstHeading" class="firstHeading m-0">{{ location.name }}</h4>
                            <div id="bodyContent">
                                <!-- <button class="btn-small mt-2">
                                    <router-link :to="'../cases/' + location.uid">{{ $t('map.details')
                                        }}</router-link>
                                </button> -->
                                <button class="btn-small mt-2">
                                    <router-link
                                        :to="{ path: 'cases/' + location.uid, query: { name: location.name } }">{{
                                            $t('map.details')
                                        }}</router-link>
                                </button>
                            </div>
                        </div>
                    </InfoWindow>
                </Marker>
            </MarkerCluster>
            <div v-else>
                <Marker v-for="location in filteredLocations" :key="location.name"
                    :options="{ position: { lat: parseFloat(location.lat), lng: parseFloat(location.lng) } }">
                    <InfoWindow @closeclick="hidePanel()" :ref="(el) => (infoWindows[location.name] = el)">
                        <div class="content">
                            <h4 id="firstHeading" class="firstHeading m-0">{{ location.name }}</h4>
                            <div id="bodyContent">
                                <button class="btn-small mt-2">
                                    <router-link
                                        :to="{ path: 'cases/' + location.uid, query: { name: location.name } }">{{
                                            $t('map.details')
                                        }}</router-link>
                                </button>
                            </div>
                        </div>
                    </InfoWindow>
                </Marker>
            </div>
            <Polygon :options="bermudaTriangle" />
        </GoogleMap>
    </div>
</template>

<script>

import axios from 'axios'
import { defineComponent, toRaw } from "vue";
import Filter from "./Filter.vue";
import Panel from "./Panel.vue";
import { GoogleMap, MarkerCluster, Marker, InfoWindow, Polygon } from "vue3-google-map";
import moment from 'moment';
import triangleCoords from "../assets/city.js";
const base_url = process.env.VUE_APP_BASE_URL;


export default defineComponent({
    components: {
        Panel,
        Filter,
        GoogleMap,
        MarkerCluster,
        Marker,
        InfoWindow,
        Polygon,
    },
    data() {
        return {
            panelShow: false,
            openMarker: null,
            events: [],
            locations: [],
            filteredLocations: [],
            caseTitle_number: "",
            accusedName_accusations: "",
            referralYear: "",
            governorates: [],
            authoritiers: [],
            infoWindows: [],
            triangleCoords,
            bermudaTriangle: "",
            zoom: 6,
            center: { lat: 28.156486, lng: 30.191588 },
            enable_clustering: 0
        }
    },
    beforeMount() {
        this.get_enable_clustering();
        this.fetchLocations();
    },
    methods: {
        showPanel() {
            this.panelShow = true
        },
        hidePanel() {
            this.panelShow = false
        },
        closeInfoWindows(except) {
            this.infoWindows.forEach((ref, index) => {
                if (index !== except) ref.infoWindow.close();
            });
        },

        // Render cases to side panel
        async fetchCases() {
            let params = new URLSearchParams();

            params.append('filter[search_text]', this.caseTitle_number);
            params.append('filter[search_text_2]', this.accusedName_accusations);
            params.append('filter[referral_date_year]', this.referralYear);
            params.append('filter[governorate]', this.governorates);
            params.append('filter[referral_authority]', this.authoritiers);

            const res = await fetch(base_url + '/cases/get_cases?' + params);
            const events = await res.json();

            return events.data

        },
        async renderPanel() {
            this.closeInfoWindows();
            this.events = await this.fetchCases();
        },

        // Render filtered locations
        async fetchLocations() {
            this.closeInfoWindows(null);
            this.infoWindows = [];

            const res = await fetch(base_url + '/get_courts')
            const locations = await res.json();

            return locations.data
        },

        filterLocations(cases) {
            let filteredCourtsIDs = [...new Map(cases.map(court => [court.court_id, court])).keys()];
            let filteredCourts = this.locations.filter(court => filteredCourtsIDs.includes(court.id));
            return filteredCourts;
        },

        async filterAll(openPanel) {
            this.caseTitle_number = this.$store.state.caseTitle_number;
            this.accusedName_accusations = this.$store.state.accusedName_accusations;
            this.referralYear = this.$store.state.referralYear ? this.$store.state.referralYear : "";
            this.governorates = this.$store.state.selectedGovernorates ? this.$store.state.selectedGovernorates : [];
            this.authoritiers = this.$store.state.selectedAuthorities ? this.$store.state.selectedAuthorities : [];

            this.events = await this.fetchCases();
            this.filteredLocations = this.filterLocations(this.events);


            // let obj = [];
            // const coordinates = [];

            // for (let index = 0; index < this.filteredStates.length; index++) {
            //     const element = this.filteredStates[index];
            //     obj[index] = triangleCoords.find((o, i) => {
            //         if (o.city === element) {
            //             this.center = o.center;
            //             this.zoom = 8;
            //             return o.coordinates;
            //         }
            //     });
            // }
            // var nameArray = obj.map(function (el) { return el.coordinates; });

            // nameArray.forEach(function (item, i) {
            //     coordinates[i] = buildCoordinatesArrayFromString(item);
            // });

            // this.bermudaTriangle = {
            //     paths: coordinates,
            //     strokeColor: "#1ebb69",
            //     strokeOpacity: 0.5,
            //     strokeWeight: 2,
            //     fillColor: "#1ebb69",
            //     fillOpacity: .7,
            // };
            if (openPanel) {
                this.showPanel();
            } else {
                this.hidePanel();
            }
        },

        get_enable_clustering() {
            axios
                .get(base_url + "/get_setting/enable_clustering")
                .then((response) => {
                    this.enable_clustering = response.data.data;

                })
        },
    },

    async created() {
        this.locations = await this.fetchLocations();
        this.filteredLocations = this.locations;
    },

    setup() {
        //const center = { lat: 27.156486, lng: 30.491588 };
        const mapStyle = [
            {
                "featureType": "all",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "weight": "2.00"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "geometry.stroke",
                "stylers": [
                    {
                        "color": "#9c9c9c"
                    }
                ]
            },
            {
                "featureType": "all",
                "elementType": "labels.text",
                "stylers": [
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#f2f2f2"
                    }
                ]
            },
            {
                "featureType": "landscape",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "landscape.man_made",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "poi",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "all",
                "stylers": [
                    {
                        "saturation": -100
                    },
                    {
                        "lightness": 45
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#eeeeee"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#7b7b7b"
                    }
                ]
            },
            {
                "featureType": "road",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            },
            {
                "featureType": "road.highway",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "simplified"
                    }
                ]
            },
            {
                "featureType": "road.arterial",
                "elementType": "labels.icon",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "transit",
                "elementType": "all",
                "stylers": [
                    {
                        "visibility": "off"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "all",
                "stylers": [
                    {
                        "color": "#46bcec"
                    },
                    {
                        "visibility": "on"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "geometry.fill",
                "stylers": [
                    {
                        "color": "#c8d7d4"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.fill",
                "stylers": [
                    {
                        "color": "#070707"
                    }
                ]
            },
            {
                "featureType": "water",
                "elementType": "labels.text.stroke",
                "stylers": [
                    {
                        "color": "#ffffff"
                    }
                ]
            }
        ];


        return { mapStyle };
    },

    mounted() {
        const coordinates = [];
        // const triangleCoords = [];
        var nameArray = triangleCoords.map(function (el) { return el.coordinates; });
        nameArray.forEach(function (item, i) {
            coordinates[i] = buildCoordinatesArrayFromString(item);
        });

        this.bermudaTriangle = {
            paths: coordinates,
            strokeColor: "#b41412",
            strokeOpacity: 0.3,
            strokeWeight: 1,
            fillColor: "#b41412",
            fillOpacity: 0,

        };
    }
});

function buildCoordinatesArrayFromString(MultiGeometryCoordinates) {
    var finalData = [];
    var grouped = MultiGeometryCoordinates.split(" ");

    grouped.forEach(function (item, i) {
        let a = item.trim().split(',');

        finalData.push({
            lng: parseFloat(a[0]),
            lat: parseFloat(a[1])
        });
    });

    return finalData;
}
</script>

<style scoped>
.map-view {
    display: flex;
}

.map {
    margin-right: 0;
    transition: 0.3s;
    width: 100%;
    height: calc(100svh - 100px);
}

.map .content button {
    background-color: var(--mainColor);
}

.panel {
    z-index: 1050;
}

.panel.show+.map {
    margin-right: 300px;
}

.rtl .panel.show+.map {
    margin-right: 0;
    margin-left: 300px;
}

.filter:has(+.panel.show) {
    margin-right: 300px;
}

.rtl .filter:has(+.panel.show) {
    margin-right: 0;
    margin-left: 300px;
}

@media(max-width: 992px) {
    .map {
        height: calc(100svh - 120px);
    }
}

@media(max-width: 768px) {
    .panel.show+.map {
        margin-right: 250px;
    }

    .rtl .panel.show+.map {
        margin-right: 0;
        margin-left: 250px;
    }

    .filter:has(+.panel.show) {
        width: calc(100% - 80px - 250px);
        margin-right: 250px;
    }

    .rtl .filter:has(+.panel.show) {
        margin-right: 0;
        margin-left: 250px;
    }
}

@media (max-width: 567px) {
    .filter:has(+.panel.show) {
        width: calc(100% - 80px);
        margin-right: 0;
    }

    .rtl .filter:has(+.panel.show) {
        margin-right: 0;
        margin-left: 0;
    }
}
</style>
